import DeleteIcon from "@mui/icons-material/Delete";
import {
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";

const MultipleInvoiceItems = ({
	register,
	allPaymentableItem,
	index,
	control,
	remove,
	fields,
	setValue,
}: any) => {
	const itemID = useWatch({
		control,
		name: `items.${index}.id`,
	});
	const quantity = useWatch({
		control,
		name: `items.${index}.quantity`,
	});

	useEffect(() => {
		const findPaymentItem = allPaymentableItem?.find(
			(item) => item.id === Number(itemID)
		);
		if (findPaymentItem?.id) {
			setValue(`items.${index}.amount`, Number(findPaymentItem?.amount));
		} else {
			setValue(`items.${index}.amount`, 0);
		}
	}, [itemID, quantity]);

	return (
		<>
			<Grid
				container
				alignItems='center'
				sx={{
					background: "#f8f9f9",
					borderRadius: "15px",
					p: "5px",
					mb: 1,
				}}
				columnGap={1}
				rowGap={1}
			>
				<Grid item xs={12} md={12} lg={4}>
					<Controller
						control={control}
						name={`items.${index}.id`}
						render={({ field }) => (
							<FormControl
								sx={{ mt: 1 }}
								fullWidth
								required
								margin='normal'
							>
								<InputLabel id={`select-item-label-${index}`}>
									Select Item
								</InputLabel>
								<Select
									labelId={`select-item-label-${index}`}
									id={`select-item-${index}`}
									{...field} // Integrates React Hook Form's control
									label='Expense Head'
								>
									{allPaymentableItem?.map((item) => (
										<MenuItem key={item.id} value={item.id}>
											{item.name} ({item.amount} bdt)
										</MenuItem>
									))}
								</Select>
							</FormControl>
						)}
					/>
				</Grid>
				<Grid item xs={12} md={12} lg={2}>
					<TextField
						fullWidth
						required
						label='Amount'
						type='number'
						variant='outlined'
						{...register(`items.${index}.amount`)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</Grid>

				<Grid item xs={12} md={12} lg={2}>
					<Controller
						control={control}
						name={`items.${index}.quantity`}
						defaultValue={1} // Ensures the default value is always 1
						render={({ field }) => {
							return (
								<TextField
									fullWidth
									label='Quantity'
									type='number'
									variant='outlined'
									value={field.value} // Fallback to 1 if value is undefined or null
									onChange={field.onChange} // Ensure React Hook Form tracks changes
									InputLabelProps={{
										shrink: true,
									}}
								/>
							);
						}}
					/>
				</Grid>
				<Grid item xs={12} md={12} lg={3}>
					<TextField
						fullWidth
						label='Description'
						type='text'
						variant='outlined'
						{...register(`items.${index}.description`)}
						placeholder='description'
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</Grid>
				{
					<Grid item>
						<IconButton
							disabled={fields.length === 1}
							onClick={() => remove(index)}
							color='error'
						>
							<DeleteIcon />
						</IconButton>
					</Grid>
				}
			</Grid>
		</>
	);
};

export default MultipleInvoiceItems;
